import { useContext } from 'react';
import { SessionContext } from '../SessionContext';

// Throws if used outside the provider, which makes "no session in this tree"
// fail loudly at the call site rather than silently returning undefined.
export function useSession() {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession must be used inside SessionProvider');
  return ctx;
}
